import 'twin.macro';
import React from 'react';
import loadable from '@teetsh/app/src/utils/loadable';

const LoadableComponent = () => (
  <div tw="w-full h-64" className="tsh-skeleton" />
);
export default loadable(() => import('./index'), {
  fallback: <LoadableComponent />,
});
